module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/RDC_RED_Logo_House.svg";